import { AxiosInstance } from "axios";
import axiosBase from "./base";
import { el } from "date-fns/locale";

class NewsAndMediaService {
  base: AxiosInstance;

  constructor() {
    this.base = axiosBase.base;
  }
  getNewsArticles(
    page = 1,
    pageSize = 6,
    search = ""
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchParams = new URLSearchParams();
        searchParams.append("pagination[page]", page.toString());
        searchParams.append("pagination[pageSize]", pageSize.toString());
        if (search) {
          searchParams.append("filters[title][$containsi]", search);
        }
        const { data } = await this.base.get(
          `news-articles?populate=cover&${searchParams.toString()}`
        );
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getNewsArticlesByCategory(
    page = 1,
    pageSize = 6,
    search = "",
    id: number
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchParams = new URLSearchParams();
        searchParams.append("pagination[page]", page.toString());
        searchParams.append("pagination[pageSize]", pageSize.toString());
        searchParams.append("sort", "publishedAt:desc");

        if (search) {
          searchParams.append("filters[title][$containsi]", search);
        }

        const { data } = await this.base.get(
          `news-articles/?populate=*&sort=article_date:desc&filters[news_category_ids]=${id}&${searchParams.toString()}`
        );
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getNewsArticlesById(id: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await this.base.get(
          `news-articles/${id}?populate[gallery][populate]=*&populate[partener][populate]=*&populate[cover][populate]=*`
        );
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getLegislationMajorEvents(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await this.base.get(
          `major-events-legislations?populate[documents][populate]=*`
        );
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getNewsCategoriesWithPaginatedArticles(
    categoryId: number,
    page = 1,
    pageSize = 6
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchParams = new URLSearchParams();
        searchParams.append("populate[news_articles_ids][populate]", "cover");
        searchParams.append(
          "populate[news_articles_ids][pagination][page]",
          page.toString()
        );
        searchParams.append(
          "populate[news_articles_ids][pagination][pageSize]",
          pageSize.toString()
        );
        // if (search) {
        //     searchParams.append('filters[title][$containsi]', search);
        // }
        const { data } = await this.base.get(
          `news-categories/${categoryId}?${searchParams.toString()}`
        );
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getBrochuresByDir(
    dir: string,
    page = 1,
    pageSize = 10
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchParams = new URLSearchParams();
        searchParams.append("filters[dir][$eq]", dir);
        searchParams.append("pagination[page]", page.toString());
        searchParams.append("pagination[pageSize]", pageSize.toString());

        const { data } = await this.base.get(
          `brochures?populate[document_id][populate]=attached_document&${searchParams.toString()}`
        );
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getEvents(
    page = 1,
    pageSize = 6,
    search = "",
    filterType: string,
    month?: number,
    year?: number,
    eventType?: string,
    isFirst = true
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchParams = new URLSearchParams();
        const currentDate = new Date();
        const currentDateISO = currentDate.toISOString().split("T")[0];

        searchParams.append("pagination[page]", page.toString());
        searchParams.append("pagination[pageSize]", pageSize.toString());

        if (search) {
          searchParams.append("filters[$or][0][title][$containsi]", search);
          searchParams.append("filters[$or][1][city][$containsi]", search);
          searchParams.append(
            "filters[$or][2][partner_event][$containsi]",
            search
          );
        }

        let fullYear: number;
        let selectedMonth: number;

        if (year !== undefined) {
          fullYear = 2000 + year;
        } else {
          fullYear = currentDate.getFullYear();
        }

        if (month !== undefined) {
          selectedMonth = month;
        } else {
          selectedMonth = currentDate.getMonth();
        }
        const startDateObj = new Date(fullYear, selectedMonth, 1);
        const endDateObj = new Date(fullYear, selectedMonth + 1, 0, 23, 59, 59);
        const startDateISO = startDateObj.toISOString().split("T")[0];
        const endDateISO = endDateObj.toISOString().split("T")[0];
        // console.log(startDateISO,currentDateISO,endDateISO)
        // console.log(filterType, startDateISO, endDateISO);
        if (filterType === "month") {
          // console.log("mo yyy");
          searchParams.append("filters[end_date][$gte]", startDateISO);
          //searchParams.append("filters[start_date][$lte]", endDateISO);
        } else if (filterType === "upcoming") {
          // console.log("xxxxxxxxx uc", isFirst);
          if (startDateISO > currentDateISO) {
            searchParams.append("filters[start_date][$gte]", startDateISO);
            if (!isFirst) {
              searchParams.append("filters[end_date][$lte]", endDateISO);
            }
          } else {
            if (!isFirst) {
              searchParams.append("filters[end_date][$lte]", endDateISO);
            }
            searchParams.append("filters[end_date][$gte]", startDateISO);
          }
        } else if (filterType === "past") {
          if (endDateISO > currentDateISO) {
            // console.log("xxxxxxxxx");
            //searchParams.append("filters[start_date][$gte]", startDateISO);
            searchParams.append("filters[end_date][$lt]", currentDateISO);
          } else {
            // console.log("yyyyyyyy", startDateISO, endDateISO);
            //searchParams.append("filters[start_date][$gte]", startDateISO);
            searchParams.append("filters[end_date][$lte]", endDateISO);
          }
        }
        if (eventType === "DSU") {
          searchParams.append("filters[partner_event][$eq]", "false");
        } else if (eventType === "partner") {
          searchParams.append("filters[partner_event][$eq]", "true");
        }

        const { data } = await this.base.get(
          `events?populate=*&${searchParams.toString()}&sort=start_date:ASC`
        );
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getProjects(
    page = 1,
    pageSize = 6,
    search = "",
    filters: { current?: boolean; past?: boolean } = {}
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchParams = new URLSearchParams();
        searchParams.append("pagination[page]", page.toString());
        searchParams.append("pagination[pageSize]", pageSize.toString());

        const today = new Date().toISOString().split("T")[0]; // Format: YYYY-MM-DD

        if (filters.current) {
          searchParams.append("filters[end_date][$gte]", today);
        } else if (filters.past) {
          searchParams.append("filters[end_date][$lt]", today);
        }
        if (search) {
          searchParams.append("filters[title][$containsi]", search);
          // searchParams.append('filters[$or][1][city][$containsi]', search);
          // searchParams.append('filters[$or][2][partener][$containsi]', search);
        }

        const { data } = await this.base.get(
          `projects?populate=*&${searchParams.toString()}`
        );
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getMapEvents(search = ""): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchParams = new URLSearchParams();

        if (search) {
          searchParams.append("&filters[$or][0][title][$containsi]", search);
          searchParams.append("filters[$or][1][city][$containsi]", search);
          searchParams.append("filters[$or][2][partener][$containsi]", search);
        }

        const { data } = await this.base.get(
          `events?populate=photo&populate=partener_logo${searchParams.toString()}`
        );
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getLastEvents(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const page = 1;
        const pageSize = 3;
        const searchParams = new URLSearchParams();
        searchParams.append("pagination[page]", page.toString());
        searchParams.append("pagination[pageSize]", pageSize.toString());

        const { data } = await this.base.get(
          `events?populate=photo&${searchParams.toString()}`
        );
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getEventById(id: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await this.base.get(`events/${id}?populate=*`);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getLegislations(
    category: string,
    type: string,
    section: string,
    page = 1,
    pageSize = 10
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const searchParams = new URLSearchParams();
        searchParams.append("pagination[page]", page.toString());
        searchParams.append("pagination[pageSize]", pageSize.toString());
        searchParams.append("filters[category][$eq]", category);
        searchParams.append("filters[type][$eq]", type);
        searchParams.append("filters[section][$eq]", section);

        const { data } = await this.base.get(
          `legislations?populate[documents][populate]=attached_document&${searchParams.toString()}`
        );
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }

  getAgendas(year: number, month: number, day: number): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const formattedDay = `${year.toString().padStart(4, "0")}-${month
          .toString()
          .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

        const searchParams = new URLSearchParams();
        searchParams.append("filters[day][$eq]", formattedDay);

        const { data } = await this.base.get(
          `agendas?populate=*&${searchParams.toString()}`
        );
        // console.log(data);
        resolve(data);
      } catch (err) {
        reject(err);
      }
    });
  }
}

const newsAndMediaService = new NewsAndMediaService();
export default newsAndMediaService;
